module.exports = __webpack_public_path__ + "img/Red-R-3@2x.94f91330.png";